import { Routes, Route, Navigate } from 'react-router-dom';

import AuthRoutes from './AuthRoutes';
import PrivateRoutes from './PrivateRoutes';

import Error from '../components/pages/Error';

import Login from '../components/pages/Login';
import Programs from '../components/pages/Programs';
import Organizations from '../components/pages/Organizations';

const NavigationRoutes = () => {
    return (
        <Routes>
            <Route element={<AuthRoutes />}>
                <Route path='/auth/sign-in' element={<Login />} />
            </Route>

            <Route element={<PrivateRoutes />}>
                <Route path='/' element={<Navigate to='/programs' replace />} />
                <Route path='/programs' element={<Programs />} />
                <Route path='/organizations' element={<Organizations />} />
            </Route>

            <Route path="*" element={<Error />} />
        </Routes>
    );
};

export default NavigationRoutes;